import { BaseModel } from "~/model"
import { useRoleStore } from "~/stores"
import { RoleResource } from "~/api"

export class PersonnelModel extends BaseModel {
    static primaryKey = "IDPERSONNEL"

    get roles(): RoleResource[] {
        const roleStore = useRoleStore()
        return this.ROLES?.map((roleName) => roleStore.roleByName[roleName])
    }
}
